import { schema } from 'normalizr';
import { RSAA } from 'redux-api-middleware';
import { handleResponse, handleError, buildQueryString } from '../utils';

export const FETCH_EXPECTATIONS_REQUEST = 'FETCH_EXPECTATIONS_REQUEST';
export const FETCH_EXPECTATIONS_SUCCESS = 'FETCH_EXPECTATIONS_SUCCESS';
export const FETCH_EXPECTATIONS_FAILURE = 'FETCH_EXPECTATIONS_FAILURE';
export const CREATE_EXPECTATIONS_REQUEST = 'CREATE_EXPECTATIONS_REQUEST';
export const CREATE_EXPECTATIONS_SUCCESS = 'CREATE_EXPECTATIONS_SUCCESS';
export const CREATE_EXPECTATIONS_FAILURE = 'CREATE_EXPECTATIONS_FAILURE';
export const expectationsSchema = new schema.Entity('expectations', {}, { idAttribute: 'id' });

/**
 * Fetch an expectation.
 *
 * @param {string} transactionDate - transaction date.
 * @param {string} type - type.
 * @param {string} contractId - contractId.
 * @param {string} partnerName - partnerName.
 * @return {object} - Redux api middleware action that triggers & handles the request.
 */
export const fetchExpectations = (transactionDate, type, contractId, partnerName) => {
  let queryString = buildQueryString({
    type,
    contractId,
    partnerName,
  });
  if (transactionDate) {
    queryString += `&transactionDate=${transactionDate}`;
  }
  return {
    [RSAA]: {
      endpoint: `${window.config.auditAPIUrl}/expectations?${queryString}`,
      method: 'GET',
      types: [
        {
          type: FETCH_EXPECTATIONS_REQUEST,
        },
        {
          type: FETCH_EXPECTATIONS_SUCCESS,
          payload: (action, state, res) => handleResponse([expectationsSchema], action, state, res),
          meta: () => ({
            transactionDate,
            type,
            contractId,
            partnerName,
          }),
        },
        {
          type: FETCH_EXPECTATIONS_FAILURE,
          payload: handleError,
        },
      ],
    },
  };
};

export const createExpectation = (geography, transactionDate, partnerName, contractId) => ({
  [RSAA]: {
    endpoint: `${window.config.auditAPIUrl}/expectations`,
    method: 'POST',
    body: JSON.stringify({
      partnerName,
      contractId,
      transactionExists: {
        transactionDate,
        geography,
      },
    }),
    types: [
      { type: CREATE_EXPECTATIONS_REQUEST },
      {
        type: CREATE_EXPECTATIONS_SUCCESS,
        payload: (action, state, res) => handleResponse(expectationsSchema, action, state, res),
      },
      { type: CREATE_EXPECTATIONS_FAILURE, payload: handleError },
    ],
  },
});
